import { CsvBuilder } from 'filefy';

export const convertDateFormat = (dateString) => {
    const [datePart, timePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('/');
    const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${timePart}:37`; // Adding seconds

    return formattedDate;
};

export const handleExportCSV = (options) => {
    const { tableRef, columns, data, titleName } = options;
    tableRef.current?.props.options?.exportCsv(columns, data, titleName);
};

export const exportCsv = (
    columns,
    data,
    exportFileName,
    exportDelimiter = ',',
) => {
    const mappedData = data.map((rowData) =>
        columns.map((columnDef) => rowData[columnDef.field]),
    );
    const fileName = exportFileName.split(' ').join('_') || 'data';
    const builder = new CsvBuilder(fileName + '.csv');
    builder
        .setDelimeter(exportDelimiter)
        .setColumns(columns.map((columnDef) => columnDef.title))
        .addRows(mappedData)
        .exportFile();
};
